module.exports = __webpack_public_path__ + "static/media/dropdown-small.1609dbd4.svg";